<ub-card variant="primary" [dividers]="false" [flat]="true">
  <h4 title >
    {{ READABLE_CREDENTIAL_TYPES[credential.type] }}
    <span *ngIf="credential.type !== CredentialTypes.API">: {{ credential.username }}</span>
    <span *ngIf="credential.type === CredentialTypes.API">: {{ credential.public_key }}</span>
  </h4>
</ub-card>
